<template>
  <el-menu
    :class="`el-menu ${m} ${!isSelect ? `change-language` : `select-language`}`"
    mode="horizontal"
    @select="handleSelect"
    default-active="es"
  >
    <el-submenu index="locale">
      <template slot="title">{{ languageLabel }}</template>
      <el-menu-item
        v-for="lang in languages"
        :key="lang.locale"
        :index="lang.locale"
        >{{ lang.label }}</el-menu-item
      >
    </el-submenu>
  </el-menu>
</template>
<script>
import axios from 'axios';
import { setLocalizeElementUI } from 'src/util/Util.js';
import en from 'vee-validate/dist/locale/en';
import i18n from 'src/i18n';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import { EventBus } from '../../../src/util/bus';

export default {
  name: 'menu-translate',
  props: {
    isSelect: {
      type: Boolean,
      default: false,
    },
    showAbbreviation: {
      type: Boolean,
      default: true,
    },
    m: {
      type: String,
      default: 'mr-2',
    },
  },

  computed: {
    languages() {
      return [
        {
          locale: 'en',
          label: i18n.t('common_words.english'),
          abbreviation: 'EN',
        },
        {
          locale: 'es',
          label: i18n.t('common_words.spanish'),
          abbreviation: 'ES',
        },
        {
          locale: 'pt_BR',
          label: i18n.t('common_words.portuguese'),
          abbreviation: 'PT',
        },
      ];
    },
  },
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
      languageLabel: this.showAbbreviation
        ? 'ES'
        : i18n.t('common_words.spanish'),
    };
  },
  methods: {
    handleSelect(key) {
      this.selectedLanguage = key;
      this.languageLabel = this.getAbbreviation(key);
      this.changeLanguage();
    },

    getAbbreviation(key) {
      const result = this.languages.find((lang) => lang.locale === key);

      return this.showAbbreviation ? result.abbreviation : result.label;
    },

    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('locale', this.selectedLanguage);
      setLocalizeElementUI();

      switch (this.$i18n.locale) {
        case 'pt_BR':
          this.$validator.localize(this.$i18n.locale, ptBR);
          break;
        case 'en':
          this.$validator.localize(this.$i18n.locale, en);
          break;
        default:
          this.$validator.localize(this.$i18n.locale);
          break;
      }
      axios.defaults.headers.locale = this.$i18n.locale;
      this.changeLocale(this.selectedLanguage);
    },

    changeLocale(newLocale) {
      localStorage.setItem('locale', newLocale);
      EventBus.$emit('locale-changed', newLocale);
    },
  },
  created() {
    if (localStorage.getItem('locale')) {
      this.$i18n.locale = localStorage.getItem('locale');
      this.languageLabel = this.getAbbreviation(this.$i18n.locale);
      axios.defaults.headers.locale = this.$i18n.locale;
    }
  },
};
</script>
<style>
.select-language {
  border: 1px solid #ccc !important;
  height: 40px !important;
}
.select-language > .el-submenu.is-active > .el-submenu__title {
  border-bottom: none !important;
}

.select-language > .el-submenu.is-active > .el-submenu__title {
  display: flex;
  align-items: baseline;
  flex-direction: row;
  margin-top: -5px;
}

.select-language.el-menu--horizontal > .el-submenu > .el-submenu__title:hover {
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu.el-menu--popup.el-menu--popup-bottom-start {
  min-width: auto !important;
}

.change-language {
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  border: 1px solid #88888899 !important;
}

.change-language > .el-submenu.is-active > .el-submenu__title:hover,
.change-language > .el-submenu.is-active > .el-submenu__title:focus-within,
.change-language > .el-submenu.is-active > .el-submenu__title:focus {
  border-radius: 50px !important;
}

.change-language > .el-submenu.is-active > .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 8.5px !important;
  border-bottom: none !important;
  margin-top: -1px;
}

.change-language
  > .el-submenu.is-active
  > .el-submenu__title
  > .el-submenu__icon-arrow {
  display: none;
}

.change-language.el-menu--horizontal > .el-submenu > .el-submenu__title:hover {
  background-color: transparent !important;
}
</style>
